import axios from 'axios';
import Vue from 'vue';
import View from '../pages/forms/view.vue';
//import AppEmbed from './components/AppEmbed.vue';
//import router from './router';
//import wait from '../plugins/wait';
//import './components';
import '@groovepages/gd-ui-kit/styles.css';
import config from '../../../load-config';
import i18n from './plugins/i18n';
//import 'document-register-element/build/document-register-element';

config.then(configValues => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}/groovemail`;

  let user = JSON.parse('{}');

  try {
    if ('localStorage' in window && window.localStorage) {
      user = JSON.parse(window.localStorage.getItem('user') || '{}');
    }
  } catch (exception) {}

  if (!user.auth_keycloak) {
    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      'x-auth-provider': 'auth0'
    };
  }

  let appFrontendURL = configValues.VUE_APP_FRONTEND_URL;

  if (configValues.VUE_APP_FRONTEND_URL.includes('/groovepages')) {
    appFrontendURL = configValues.VUE_APP_FRONTEND_URL.replace(
      '/groovepages',
      ''
    );
  }
  const localConfig = {
    apiUrl: `${configValues.VUE_APP_API_URL}/groovemail`,
    appUrl: 'https://groovesell.com',
    grooveappsurl: appFrontendURL,
    apiCoreUrl: `${configValues.VUE_APP_API_URL}`
  };
  window.config = localConfig;
  window.gdEnv = configValues;

  Vue.config.productionTip = false;

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
 //   router,
    //wait,
    ...View
  });
});
